import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import { connect } from 'react-redux';
import { login, getLoggedInUser } from '../../actions/action_auth';
import { bindActionCreators } from 'redux';
import { addLocaleData, IntlProvider } from "react-intl";
import messages from "../../locale/index.js";
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
addLocaleData([...en, ...es]);

class TermsCondition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardAnimaton: "cardHidden"
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container} style={{ paddingTop: "0px" }}>
        <GridContainer justify="center" style={{ margin: 'auto' }}>
          <GridItem xs={12} style={{ margin: 'auto' }}>
            <div>
              <h2 className={classes.title}> <strong>
              {window.intl.formatMessage({id : "view.termsandconditions.termsandconditionsofuse.title"})}</strong></h2>
              <p style={{ color: "#233750", textAlign: "justify" }}
              dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.termsandconditions.termsandconditionsofuse.description"})}}
              >
              </p>

              <h4 style={{ color: "#233750", textAlign: "justify" }}>
                <strong>{window.intl.formatMessage({id : "view.termsandconditions.thefollowingterminology.title"})}</strong>
              </h4>
              <p style={{ color: "#233750", textAlign: "justify" }}
              dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.termsandconditions.thefollowingterminology.description"})}}
              >
              </p>
              <h4 style={{ color: "#233750", textAlign: "justify" }}>
                <strong>
                                {window.intl.formatMessage({id : "view.termsandconditions.cookies.title"})}
                </strong>
              </h4>
              <p style={{ color: "#233750", textAlign: "justify" }}
                dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.termsandconditions.cookies.description"})}}
              >
              </p>

              <h4 style={{ color: "#233750", textAlign: "justify" }}>
                <strong>{window.intl.formatMessage({id : "view.termsandconditions.license.title"})}</strong>
              </h4>
              <p style={{ color: "#233750", textAlign: "justify" }}
                            dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.termsandconditions.license.description"})}}
              >
              </p>
              <p style={{ color: "#233750", textAlign: "justify" }}
                dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.termsandconditions.license.youmustnot.title"})}}
              >
              </p>
              <ul style={{ color: "#233750", textAlign: "justify" }}>
                {[0,1,2,3].map(point => {return <li
                  dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : `view.termsandconditions.license.youmustnot.bullets.${point}`})}}
                >
                </li>})}
              </ul>
              <h4 style={{ color: "#233750", textAlign: "justify" }}>
                <strong>{window.intl.formatMessage({id : `view.termsandconditions.hyperlinkingtoourcontent.title`})}</strong>
              </h4>
              <p style={{ color: "#233750", textAlign: "justify" }}>
                The following organizations may link to our website without prior written approval:
              </p>
              <ul style={{ color: "#233750", textAlign: "justify" }}>
              {[0,1,2,3,4].map(point => {return <li
                  dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : `view.termsandconditions.hyperlinkingtoourcontent.bullets.${point}`})}}
                >
                </li>}
              )}
              </ul>
              <p style={{ color: "#233750", textAlign: "justify" }}
                              dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.termsandconditions.hyperlinkingtoourcontent.description.1"})}}
                              >
              </p>
              <p style={{ color: "#233750", textAlign: "justify" }}
                dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.termsandconditions.hyperlinkingtoourcontent.description.2"})}}
                >
              </p>
              <p style={{ color: "#233750", textAlign: "justify" }}
                dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.termsandconditions.hyperlinkingtoourcontent.description.3"})}}                              
                >
              </p>
              <p style={{ color: "#233750", textAlign: "justify" }}
                dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.termsandconditions.hyperlinkingtoourcontent.approvedorganizationsmayhyperlinktoourwebsiteasfollows.title"})}}                              
              >
              </p>
              <ul style={{ color: "#233750", textAlign: "justify" }}>
              {[0,1,2].map(point => {return <li
                  dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : `view.termsandconditions.hyperlinkingtoourcontent.approvedorganizationsmayhyperlinktoourwebsiteasfollows.bullets.${point}`})}}
                  >
                </li>}
              )}
              </ul>
              <p style={{ color: "#233750", textAlign: "justify" }}
                dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : `view.termsandconditions.hyperlinkingtoourcontent.nouseoflogo`})}}
                >
              </p>


              <h4 style={{ color: "#233750", textAlign: "justify" }}>
                <strong>{window.intl.formatMessage({id : `view.termsandconditions.cookies2.title`})}</strong>
              </h4>
              <p style={{ color: "#233750", textAlign: "justify" }}>
              {window.intl.formatMessage({id : `view.termsandconditions.cookies2.description`})}
              </p>

              <h4 style={{ color: "#233750", textAlign: "justify" }}>
                <strong>{window.intl.formatMessage({id : `view.termsandconditions.reservationofrights.title`})}</strong>
              </h4>
              <p style={{ color: "#233750", textAlign: "justify" }}>
              {window.intl.formatMessage({id : `view.termsandconditions.reservationofrights.description`})}
              </p>

              <h4 style={{ color: "#233750", textAlign: "justify" }}>
                <strong>{window.intl.formatMessage({id : `view.termsandconditions.removaloflinksfromourwebsite.title`})}</strong>
              </h4>
              <p style={{ color: "#233750", textAlign: "justify" }}>
              {window.intl.formatMessage({id : `view.termsandconditions.removaloflinksfromourwebsite.description`})}
              </p>

              <h4 style={{ color: "#233750", textAlign: "justify" }}>
                <strong>{window.intl.formatMessage({id : `view.termsandconditions.contentliability.title`})}</strong>
              </h4>
              <p style={{ color: "#233750", textAlign: "justify" }}>
              {window.intl.formatMessage({id : `view.termsandconditions.contentliability.description`})}
              </p>

              <h4 style={{ color: "#233750", textAlign: "justify" }}>
                <strong>{window.intl.formatMessage({id : `view.termsandconditions.disclaimer.title`})}</strong>
              </h4>
              <p style={{ color: "#233750", textAlign: "justify" }}
                dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : `view.termsandconditions.disclaimer.description.0`})}}
              >
                
              </p>
              <ul style={{ color: "#233750", textAlign: "justify" }}>
              {[0,1,2,3].map(point => {return <li
                  dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : `view.termsandconditions.disclaimer.bullets.${point}`})}}
                >
                </li>}
              )}

              </ul>
              <p style={{ color: "#233750", textAlign: "justify" }}
                              dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : `view.termsandconditions.disclaimer.description.1`})}}

              >
              </p>
              <h4 style={{ color: "#233750", textAlign: "justify" }}>
                <strong>{window.intl.formatMessage({id : `view.termsandconditions.credit.title`})}</strong>
              </h4>
              <p style={{ color: "#233750", textAlign: "justify" }}>
              {window.intl.formatMessage({id : `view.termsandconditions.credit.description`})}
              </p>

              <h4 style={{ color: "#233750", textAlign: "justify" }}>
                <strong>{window.intl.formatMessage({id : `view.termsandconditions.contact.title`})}</strong>
              </h4>
              <p style={{ color: "#233750", textAlign: "justify" }}
                dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : `view.termsandconditions.contact.description`})}}
              >
              </p>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: bindActionCreators(login, dispatch),
    getLoggedInUser: bindActionCreators(getLoggedInUser, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(loginPageStyle)(TermsCondition));